module.exports = __webpack_public_path__ + "media/images/emblems/Fahrni_blason1-4e711f4e88f756c622b65603037cd6c6.svg";